import { smartQuoteApiConnector } from 'apiConnector/smart-quote';
import { SaveDisplayedPricesRequest } from 'apiConnector/smart-quote/model';
import { useUserNotification } from 'hooks/useUserNotification';
import { useDispatch } from 'react-redux';
import { lastValueFrom } from 'rxjs';
import { smartQuoteActions } from 'state/workspaces/smart-quote/actions';
import { httpClient } from 'utils/http/httpClient';
import { extractHttpErrorMessage, HttpClientError } from 'utils/http/httpClient.model';

const useSaveDisplayedPrices = () => {
  const dispatch = useDispatch();
  const { error } = useUserNotification();

  const saveDisplayedPrices = async (saveDisplayedPricesRequest: SaveDisplayedPricesRequest) => {
    try {
      await lastValueFrom(smartQuoteApiConnector(httpClient).saveDisplayedPrices(saveDisplayedPricesRequest));
      dispatch(smartQuoteActions.updateIsDisplayedPrice(saveDisplayedPricesRequest));
    } catch (err) {
      error({
        title: extractHttpErrorMessage(err as HttpClientError) ?? {
          id: 'generic.error.message',
        },
      });
    }
  };

  return saveDisplayedPrices;
};

export default useSaveDisplayedPrices;
